angular.module("acl.visualizer.dataModel", [
  "acl.common.event",
  "acl.visualizer.model.field",
  "acl.visualizer.observer",
]);
